import { useState } from "react";
import { ArticleListItem } from "../hooks/useArticles";
import ArticleCard from "./ArticleCard";
import ArticleModal from "./ArticleModal";

interface ArticleListProps {
  articles: ArticleListItem[];
  loading?: boolean;
  emptyMessage?: string;
}

export default function ArticleList({
  articles,
  loading = false,
  emptyMessage = "記事がありません",
}: ArticleListProps) {
  const [selectedArticle, setSelectedArticle] =
    useState<ArticleListItem | null>(null);

  if (loading) {
    return (
      <div className="space-y-4">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="bg-white rounded-lg shadow-sm border p-4 animate-pulse"
          >
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-1/4 mb-3"></div>
            <div className="h-3 bg-gray-200 rounded w-full"></div>
          </div>
        ))}
      </div>
    );
  }

  if (articles.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">{emptyMessage}</div>
    );
  }

  return (
    <>
      <div className="space-y-4">
        {articles.map((article) => (
          <ArticleCard
            key={article.id}
            article={article}
            onClick={() => setSelectedArticle(article)}
          />
        ))}
      </div>

      {selectedArticle && (
        <ArticleModal
          article={selectedArticle}
          onClose={() => setSelectedArticle(null)}
        />
      )}
    </>
  );
}
